module.exports = __webpack_public_path__ + "img/handOfGreed.c8f910ec.png";